export default __webpack_public_path__ + "static/media/Linero6Closed.4c27b8cc.jpg";